module.exports = {"511423101":"止戈镇","511423102":"三宝镇","511423108":"花溪镇","511423112":"洪川镇","511423113":"余坪镇","511423114":"槽渔滩镇","511423115":"中保镇","511423116":"东岳镇","511423117":"柳江镇","511423118":"高庙镇","511423119":"瓦屋山镇","511423200":"中山乡","511423201":"将军乡","511423205":"汉王乡","511423212":"桃源乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511423.json
// module id = 2169
// module chunks = 0